import { Component, Input, Output, EventEmitter } from '@angular/core';
import { MenuItem } from '../primitives.types';

export type MenuButtonVariant = 'flat' | 'stroked' | 'icon' | 'text';

@Component({
  selector: 'kt-menu-btn',
  templateUrl: './menu-button.component.html',
  styleUrls: ['./menu-button.component.scss']
})
export class MenuButtonComponent {
  @Input() label = '';
  @Input() icon = '';
  @Input() variant: MenuButtonVariant = 'flat';
  @Input() items: MenuItem[] = [];
  @Input() disabled = false;
  @Input() color = 'primary';
  /** Hover tooltip for the trigger button. */
  @Input() tooltip: string | null = null;
  /** Icon variant only: draw a border around the trigger (matches kt-button-v1's bordered icon button). */
  @Input() bordered = false;
  /** Optional colored background theme for the trigger (matches kt-button-v1's themes, e.g. 'light', 'dark'). */
  @Input() theme: 'dark' | 'purple' | 'neutral' | 'danger' | 'muted' | 'orange' | 'light' | null = null;

  @Output() itemClick = new EventEmitter<MenuItem>();

  get themeClass() { return this.theme ? `pkt-btn--theme-${this.theme}` : ''; }

  onItemClick(item: MenuItem) {
    if (!item.disabled) this.itemClick.emit(item);
  }

  /** Keep item DOM nodes stable across change-detection so a click isn't lost when a consumer
   * binds [items] to a getter that returns a fresh array each cycle. */
  trackByIndex(index: number) { return index; }
}
